import { useQuery } from 'react-query';
import { ROUTES } from 'constants/routes';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { ErrorResponse } from 'types/network';
import { useMswManager } from 'lib/util/useMswManager';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';
import { TEST_TOKEN } from 'lib/constants/userTestData';

export const usePartnerGetRefreshToken = () => {
  const Axios = useAuthenticatedAxios();

  useMswManager(HrznGatewayMswBuilder.create().get(ROUTES.PartnerGetRefreshToken, {
    data: TEST_TOKEN
  }))

  return useQuery<string, ErrorResponse>(
    ROUTES.PartnerGetRefreshToken,
    async () => {
      const { data } = await Axios({
        method: 'get',
        url: `?route=${ROUTES.PartnerGetRefreshToken}`
      });
      return data;
    },
    {
      enabled: false
    }
  );
};
